import React, { useState, useContext, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import {
  Box,
  IconButton,
  Typography,
  Badge,
  Avatar,
  Tooltip,
  Menu as MuiMenu,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import { useTheme } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import BuildIcon from "@mui/icons-material/Build";
import GroupIcon from "@mui/icons-material/Group";
import { UserContext } from "../../UserContext";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import Logout from "../../components/Logout";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useMediaQuery } from "@mui/material";
import axios from "axios";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CategoryIcon from "@mui/icons-material/Category";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import TimelineIcon from "@mui/icons-material/Timeline";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import ReceiptIcon from '@mui/icons-material/Receipt';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
const sidebarIconComponentMapping = {
  Product: CategoryIcon,
  Employee: GroupIcon,
  Attendance: HowToRegIcon,
  Dashboard: DashboardIcon,
  Enquiry: SupportAgentIcon,
  "Activity Log": TimelineIcon,
  Service: BuildIcon,
  "Admin Page": SettingsApplicationsIcon,
  "GenerateTCO": ReceiptIcon,
  "Invoice Tab Wrapper": AttachMoneyIcon,
   "Enquiry Import": FilterAltIcon,
  new1: TimelineIcon,
  new2: BuildIcon,
  new3: ReceiptIcon,
};

function getSidebarIconComponent(name, fontSize = "2.5rem", color = "#527ae3") {
  if (name === "Dashboard") {
    return (
     <img
        src="/equip.png"
        alt="Dashboard"
        style={{
          width: "4.5rem",
          height: "5.2rem",
          marginTop: "-15px",
        }}
      />

    );
  }
  const IconComponent = sidebarIconComponentMapping[name] || HelpOutlineIcon;
  return <IconComponent style={{ fontSize, color }} />;
}

const Sidebar = (props) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [selected, setSelected] = useState("");
  const { role, user_id } = useContext(UserContext);
  const navigate = useNavigate();
  const [location, setLocation] = useState(null);
  const [messages, setMessages] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [employeeDetails, setEmployeeDetails] = useState(null);
  const [error, setError] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const [isExpanded, setIsExpanded] = useState(!isMobileOrTablet);
  const [sidebarData, setSidebarData] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const timeoutRef = useRef(null); // Ref to store timeout
  console.log(role,"rolerole");
  console.log(sidebarData,"sidebarDatasidebarData");
  
  
  const fetchData = async () => {
    console.log(role, "sdfsdf");
    try {
      // Always construct full path from scratch
      const baseUrl = "/api";
      const path = `/sidebar-permission/?role_name=${role}`;
      const fullUrl = baseUrl + path;

      const response = await axios.get(fullUrl);
      setSidebarData(response.data);
    } catch (error) {
      console.error("Error fetching sidebar data:", error);
    }
  };
  // const fetchData = async () => {
  //   try {
  //     const response = await axios.get(
  //       `api/sidebar-permission/?role_name=${role}`
  //     );
  //     setSidebarData(response.data);
  //   } catch (error) {
  //     console.error("Error fetching sidebar data:", error);
  //   }
  // };

  useEffect(() => {
    fetchData();
  }, [role]);

  function getMacDockScale(index, hoveredIndex, totalIcons) {
    if (hoveredIndex === null) return { scale: 0.9, x: 0, zIndex: 100 };
    const maxScale = 1.2;
    const minScale = 0.9;
    const maxShift = 60;
    const decayFactor = 1.1;
    const distance = Math.abs(index - hoveredIndex);
    const scale = minScale + (maxScale - minScale) * Math.exp(-distance * distance / decayFactor);
    const shift = maxShift * Math.exp(-distance * distance / decayFactor);
    const zIndex = distance === 0 ? 300 : 100 + (totalIcons - distance);
    return { scale, x: shift, zIndex };
  }

  const handleMouseEnter = (index) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setHoveredIndex(null);
    }, 1000); // 2-second delay
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const toggleSidebar = () => setIsExpanded((prev) => !prev);

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await fetch(`/api/login-location/?user_id=${user_id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        const data = await response.json();
        setLocation(data.log?.location || "Location not available");
      } catch (error) {
        console.error(error);
      }
    };
    fetchLocation();
  }, [user_id]);

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const response = await fetch(`/api/employees`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const result = await response.json();
        setEmployeeDetails(result);
      } catch (err) {
        setError(err.message);
      }
    };
    fetchEmployeeData();
  }, []);

  const fetchNotifications = async () => {
    try {
      const response = await fetch(`/api/notification/${user_id}`);
      const data = await response.json();
      setMessages(data.messages || []);
      setUnreadCount(data.unread_count || 0);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 11000);
    return () => clearInterval(interval);
  }, [user_id]);

  const getEmployeeDetails = () => {
    if (employeeDetails && user_id) {
      return employeeDetails.find((employee) => employee.id === user_id);
    }
    return null;
  };

  const loggedInEmployee = getEmployeeDetails();

  const handleMove = async (url) => {
    await fetchNotifications();
    navigate(url);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setSelected("Profile");
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelected("");
  };

  const handleProfileClick = () => {
    navigate("/profile");
    handleMenuClose();
  };

  const notificationTooltipContent = messages.length > 0 ? (
    <Box
      sx={{
        width: 400,
        p: 2,
        bgcolor: "#fff",
        borderRadius: 2,
        boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        overflowY: "auto",
        maxHeight: 450,
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: "bold",
          mb: 2,
          color: "#5f957a",
          fontSize: 22,
        }}
      >
        New Notifications
      </Typography>
      {messages.map((message, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1,
            pb: 1,
            borderBottom: index < messages.length - 1 ? "0.5px solid #e0e0e0" : "none",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Avatar
              alt="Profile"
              src={loggedInEmployee?.profile_url || ""}
              sx={{
                width: 36,
                height: 36,
                bgcolor: "#e0e0e0",
                color: "#6495ed",
                fontSize: 24,
                border: "1px solid #6495ed",
              }}
            >
              {!loggedInEmployee?.profile_url && <PersonIcon fontSize="inherit" />}
            </Avatar>
            <Box>
              <Typography variant="body1" sx={{ fontWeight: "bold", color: "#333", fontSize: 16 }}>
                {message.message}
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: "bold", color: "#333", fontSize: 14 }}>
                {message.title}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ textAlign: "right", minWidth: 110 }}>
            <Typography variant="body2" sx={{ fontWeight: "bold", color: "#333", fontSize: 15 }}>
              {message.balance}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                fontWeight: "bold",
                color: "#333",
                textTransform: "uppercase",
                fontSize: 12,
              }}
            >
              {new Date(message.created_at).toLocaleString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              })}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                display: "block",
                fontWeight: "bold",
                color: "#333",
                fontSize: 12,
              }}
            >
              {new Date(message.created_at).toLocaleString("en-US", {
                hour: "numeric",
                minute: "numeric",
                hour12: true,
              })}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  ) : (
    <Typography variant="body2">No new notifications</Typography>
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        gap: "5px",
        overflow: "visible",
      }}
    >
      <Box
        sx={{
          display: isExpanded ? "flex" : "none",
          flexDirection: "column",
          height: "100%",
          gap: "5px",
          transition: "width 0.3s ease",
          overflow: "visible",
        }}
      >
                  <img
            src="/2.png"
            alt="Sidebar Top"
            className="top-img"
            style={{
              width: 92,
              height: 52,
              margin: "16px 5px",
              // position: "fixed",
            }}
          />
        <Box
          sx={{
            border: "3px solid #fb7102",
            borderTopRightRadius: "20px",
            borderBottomRightRadius: "20px",
            paddingLeft: "0px !important",
            height: "65%",
            // marginTop:"70px",
            overflow: "visible",
            "& .pro-sidebar": {
              width: "90px !important",
              minWidth: "90px !important",
              marginTop: "-40px !important",
              overflow: "visible",
            },
            "& .pro-sidebar-inner": {
              background: `white !important`,
              overflow: "visible",
            },
            "& .pro-icon-wrapper": {
              backgroundColor: "transparent !important",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
            "& .pro-inner-item": {
              padding: "5px 0 !important",
              display: "flex",
              justifyContent: "center",
            },
            "& .pro-inner-item:hover": {
              animation: "none",
            },
            "& .pro-menu-item .pro-inner-item .pro-item-content": {
              display: "none",
            },
          }}
        >

          <div
            className="custom-sidebar"
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
              overflowY: "scroll",
              overflowX: "visible",
              msOverflowStyle: "none",
              scrollbarWidth: "none",
            }}
          >
            <div
              style={{
                flex: 1,
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "visible",
              }}
            >
              <Box collapsed={false}>
                <div
                  style={{
                    width: 200,

                    height: "60vh",

                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "absolute",
                    top: 95,
                    left: -52,
                    overflow: "visible",
                    // paddingTop: 30,

                    //                     width: 200,
//                     height: "53vh",
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     position: "absolute",
//                     top: 70,
//                     left: -39,
                    overflowX: "visible", // Always show horizontal scrollbar
                    overflowY: "auto", 
                  }}
                >
                  {sidebarData.map((item, index) => {
                    const { scale, x, zIndex } = getMacDockScale(index, hoveredIndex, sidebarData.length);
                    const isHovered = hoveredIndex === index;

                    return (
                      <Tooltip
                        key={item.sidebar_name}
                        title={item.sidebar_name}
                        placement="right"
                        arrow
                        componentsProps={{
                          tooltip: {
                            sx: {
                              fontSize: "0.95rem",
                              padding: "8px 12px",
                              backgroundColor: "#f5f7fa",
                              color: "#333",
                              boxShadow: "0 4px 20px rgba(80, 100, 200, 0.10)",
                            },
                          },
                          arrow: {
                            sx: {
                              color: "#f5f7fa",
                            },
                          },
                        }}
                      >
                        <motion.div
                          style={{
                            margin: "32px 0",
                            position: "relative",
                            overflow: "visible",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: zIndex,
                          }}
                          animate={{
                            scale,
                            x,
                            y: scale > 1 ? -10 * (scale - 1) : 0,
                          }}
                          transition={{
                            type: "spring",
                            stiffness: 300,
                            damping: 60,
                            mass: 2,
                          }}
                          onMouseEnter={() => handleMouseEnter(index)}
                          onMouseLeave={handleMouseLeave}
                          onClick={() => {
                            setSelected(item.sidebar_name);
                            navigate(item.action_link);
                            if (props.onNavigate) props.onNavigate(item.action_link);
                          }}
                        >
                          <div
                            className="icon-container"
                            style={{
                              borderRadius: "50%",
                              width: 40,
                              height: 40,
                              gap: "10px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              position: "absolute",
                              overflow: "visible",
                            }}
                          >
                            <IconButton
                              style={{
                                fontSize: "2rem",
                                color: isHovered ? "#4053b8" : "#527ae3",
                                background: "none",
                                border: "none",
                                boxShadow: "none",
                                margin: "10px 0 0 0",
                              }}
                              disableRipple
                              disableFocusRipple
                            >
                              {getSidebarIconComponent(item.sidebar_name)}
                            </IconButton>
                          </div>
                        </motion.div>
                      </Tooltip>
                    );
                  })}
                </div>
              </Box>
            </div>
          </div>
        </Box>
        <Box
          sx={{
            border: "3px solid #fb7102",
            borderTopRightRadius: "20px",
            borderBottomRightRadius: "20px",
            height: "25%",
            overflow: "scroll",
            "& .pro-sidebar .pro-menu": {
              paddingBottom: "0px",
            },
            "& .pro-sidebar": {
              width: "90px !important",
              minWidth: "90px !important",
              overflow: "visible",
            },
            "& .pro-sidebar-inner": {
              background: `white !important`,
              overflow: "visible",
            },
            "& .pro-icon-wrapper": {
              backgroundColor: "transparent !important",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
            "& .pro-inner-item": {
              padding: "0px 0 !important",
              display: "flex",
              justifyContent: "center",
            },
            "& .pro-inner-item:hover": {
              color: "#868dfb !important",
            },
            "& .pro-menu-item.active": {
              color: "#6870fa !important",
            },
            "& .pro-menu-item .pro-inner-item .pro-item-content": {
              display: "none",
            },
          }}
        >
          <div
            style={{
              marginTop: "5px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <ProSidebar collapsed={false}>
              <Menu>
                <Box
                  paddingLeft="0"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <MenuItem
                    icon={
                      <Tooltip
                        title={notificationTooltipContent}
                        placement="right"
                        componentsProps={{
                          tooltip: {
                            sx: {
                              fontSize: "1.25rem",
                              padding: "10px 16px",
                              backgroundColor: "#f5f7fa",
                              color: "#333",
                              boxShadow: "0 4px 20px rgba(80, 100, 200, 0.10)",
                            },
                          },
                        }}
                      >
                        <span style={{ marginTop: "10px" }}>
                          <IconButton
                            style={{
                              color: selected === "Notifications" ? "#6870fa" : "#527ae3",
                            }}
                            onClick={() => {
                              setSelected("Notifications");
                            }}
                          >
                            <Badge badgeContent={unreadCount} color="error">
                              <NotificationsActiveIcon style={{ fontSize: "2.8rem" }} />
                            </Badge>
                          </IconButton>
                        </span>
                      </Tooltip>
                    }
                  />
                  <MenuItem
                    icon={
                      <Tooltip
                        title={location || "Location not available"}
                        placement="right"
                        arrow
                        componentsProps={{
                          tooltip: {
                            sx: {
                              fontSize: "0.95rem",
                              padding: "8px 12px",
                            },
                          },
                          arrow: {
                            sx: {
                              color: "#f5f7fa",
                            },
                          },
                        }}
                      >
                        <span>
                          <IconButton
                            style={{
                              color: selected === "Location" ? "#6870fa" : "#527ae3",
                            }}
                            onClick={() => setSelected("Location")}
                          >
                            <FmdGoodIcon style={{ fontSize: "3rem" }} />
                          </IconButton>
                        </span>
                      </Tooltip>
                    }
                  />
                  <MenuItem
                    icon={
                      <IconButton
                        style={{
                          color: selected === "Profile" ? "#6870fa" : "#527ae3",
                        }}
                        onClick={handleMenuOpen}
                      >
                        {loggedInEmployee ? (
                          <Avatar
                            alt="Profile Picture"
                            src={loggedInEmployee.profile_url}
                            sx={{ width: 36, height: 36 }}
                          />
                        ) : (
                          <PersonIcon style={{ fontSize: "2.8rem" }} />
                        )}
                      </IconButton>
                    }
                  />
                  <MuiMenu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleMenuClose}
                    PaperProps={{
                      style: {
                        maxHeight: 48 * 4.5,
                        width: "22ch",
                        borderRadius: "12px",
                        background: "#f5f7fa",
                        boxShadow: "0 4px 20px rgba(80, 100, 200, 0.10)",
                        marginLeft: "7%",
                      },
                    }}
                    MenuListProps={{
                      sx: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 1.5,
                        paddingY: 1,
                      },
                    }}
                  >
                    <MenuItem
                      onClick={handleProfileClick}
                      sx={{
                        color: "#527ae3",
                        "&:hover": {
                          background: "#e3e8fd",
                          color: "#4053b8",
                        },
                      }}
                    >
                      <Box display="flex" flexDirection="row" alignItems="left">
                        <PersonIcon sx={{ fontSize: "28px", color: "#527ae3" }} />
                        <Typography sx={{ fontSize: "20px", color: "gray" }}>
                          Profile
                        </Typography>
                      </Box>
                    </MenuItem>
                    <MenuItem value="LogOut" func={props.setIsLoggedIn}>
                      <Logout func={props.setIsLoggedIn} />
                    </MenuItem>
                  </MuiMenu>
                </Box>
              </Menu>
            </ProSidebar>
          </div>
        </Box>
      </Box>
      <IconButton
        onClick={toggleSidebar}
        sx={{
          position: "absolute",
          left: isExpanded ? "90px" : "0px",
          top: "40%",
          transform: "translateY(-50%)",
          backgroundColor: "#fff",
          border: "3px solid #fb7102",
          zIndex: 100,
          borderRadius: "50%",
          "&:hover": {
            backgroundColor: "#fb7102",
          },
        }}
      >
        {isExpanded ? <ChevronLeftIcon /> : <ChevronRightIcon />}
      </IconButton>
    </Box>
  );
};

export default Sidebar;





// import React, { useState, useContext, useEffect, useRef } from "react";
// import { motion } from "framer-motion";
// import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
// import {
//   Box,
//   IconButton,
//   Typography,
//   Badge,
//   Avatar,
//   Tooltip,
//   Menu as MuiMenu,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import "react-pro-sidebar/dist/css/styles.css";
// import { tokens } from "../../theme";
// import { useTheme } from "@mui/material";
// import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
// import BuildIcon from "@mui/icons-material/Build";
// import GroupIcon from "@mui/icons-material/Group";
// import { UserContext } from "../../UserContext";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import PersonIcon from "@mui/icons-material/Person";
// import Logout from "../../components/Logout";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import { useMediaQuery } from "@mui/material";
// import axios from "axios";
// import DashboardIcon from "@mui/icons-material/Dashboard";
// import CategoryIcon from "@mui/icons-material/Category";
// import HowToRegIcon from "@mui/icons-material/HowToReg";
// import SupportAgentIcon from "@mui/icons-material/SupportAgent";
// import TimelineIcon from "@mui/icons-material/Timeline";
// import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
// import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
// import FmdGoodIcon from "@mui/icons-material/FmdGood";
// import InterpreterModeIcon from "@mui/icons-material/InterpreterMode";
// import Diversity2Icon from "@mui/icons-material/Diversity2";
// import ImportExportIcon from '@mui/icons-material/ImportExport';
// import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
// import ReceiptIcon from '@mui/icons-material/Receipt';
// const sidebarIconComponentMapping = {
//   Product: CategoryIcon,
//   Employee: GroupIcon,
//   Attendance: HowToRegIcon,
//   Dashboard: DashboardIcon,
//   "Sales Funnel": Diversity2Icon,
//   "Activity Log": TimelineIcon,
//   Service: BuildIcon,
//   "Admin Page": SettingsApplicationsIcon,
//   "Generate Invoice": ReceiptIcon,
//   "Invoice Tab Wrapper": AttachMoneyIcon,
//   "Enquiry Import": ImportExportIcon,
//   new1: TimelineIcon,
//   new2: BuildIcon,
//   new3: SettingsApplicationsIcon,

// };

// function getSidebarIconComponent(name, fontSize = "2.5rem", color = "#527ae3") {
//   if (name === "Dashboard") {
//     return (
//       <img
//         src="/equip.png"
//         alt="Dashboard"
//         style={{
//           width: "4.0rem",
//           height: "4.0rem",
//           marginTop: "-15px",
//         }}
//       />
//     );
//   }
//   const IconComponent = sidebarIconComponentMapping[name] || HelpOutlineIcon;
//   return <IconComponent style={{ fontSize, color }} />;
// }

// const Sidebar = (props) => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const [selected, setSelected] = useState("");
//   const { role, user_id } = useContext(UserContext);
//   const navigate = useNavigate();
//   const [location, setLocation] = useState(null);
//   const [messages, setMessages] = useState([]);
//   const [unreadCount, setUnreadCount] = useState(0);
//   const [employeeDetails, setEmployeeDetails] = useState(null);
//   const [error, setError] = useState(null);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const open = Boolean(anchorEl);
//   const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
//   const [isExpanded, setIsExpanded] = useState(!isMobileOrTablet);
//   const [sidebarData, setSidebarData] = useState([]);
//   const [hoveredIndex, setHoveredIndex] = useState(null);
//   const timeoutRef = useRef(null); // Ref to store timeout
//   console.log(messages, "messages");
//   console.log(sidebarData, "sidebarDatasidebarData");

//   const fetchData = async () => {
//     console.log(role, "sdfsdf");
//     try {
//       // Always construct full path from scratch
//       const baseUrl = "/api";
//       const path = `/sidebar-permission/?role_name=${encodeURIComponent(role)}`;
//       const fullUrl = baseUrl + path;

//       const response = await axios.get(fullUrl);
//       setSidebarData(response.data);
//     } catch (error) {
//       console.error("Error fetching sidebar data:", error);
//     }
//   };
//   // ---------------------------------------------------------

//   // axios.defaults.baseURL = 'https://192.168.1.36:8000';

//   // const fetchData = async () => {
//   //   try {
//   //     const response = await axios.get(`/sidebar-permission/?role_name=${role}`);
//   //     setSidebarData(response.data);
//   //   } catch (error) {
//   //     console.error("Error fetching sidebar data:", error);
//   //   }
//   // };
//   // -------------------------------------------------------
//   useEffect(() => {
//     fetchData();
//   }, [role]);

//   function getMacDockScale(index, hoveredIndex, totalIcons) {
//     if (hoveredIndex === null) return { scale: 0.9, x: 0, zIndex: 100 };
//     const maxScale = 1.2;
//     const minScale = 0.9;
//     const maxShift = 35;
//     const decayFactor = 1.1;
//     const distance = Math.abs(index - hoveredIndex);
//     const scale =
//       minScale +
//       (maxScale - minScale) * Math.exp((-distance * distance) / decayFactor);
//     const shift = maxShift * Math.exp((-distance * distance) / decayFactor);
//     const zIndex = distance === 0 ? 300 : 100 + (totalIcons - distance);
//     return { scale, x: shift, zIndex };
//   }

//   const handleMouseEnter = (index) => {
//     if (timeoutRef.current) {
//       clearTimeout(timeoutRef.current);
//     }
//     setHoveredIndex(index);
//   };

//   const handleMouseLeave = () => {
//     timeoutRef.current = setTimeout(() => {
//       setHoveredIndex(null);
//     }, 1000); // 2-second delay
//   };

//   useEffect(() => {
//     return () => {
//       if (timeoutRef.current) {
//         clearTimeout(timeoutRef.current);
//       }
//     };
//   }, []);

//   const toggleSidebar = () => setIsExpanded((prev) => !prev);

//   useEffect(() => {
//     const fetchLocation = async () => {
//       try {
//         const response = await fetch(
//           `/api/login-location/?user_id=${user_id}`,
//           {
//             method: "GET",
//             headers: {
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setLocation(data.log?.location || "Location not available");
//       } catch (error) {
//         console.error(error);
//       }
//     };
//     fetchLocation();
//   }, [user_id]);

//   useEffect(() => {
//     const fetchEmployeeData = async () => {
//       try {
//         const response = await fetch(`/api/employees`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//           },
//         });
//         if (!response.ok) {
//           throw new Error("Failed to fetch data");
//         }
//         const result = await response.json();
//         setEmployeeDetails(result);
//       } catch (err) {
//         setError(err.message);
//       }
//     };
//     fetchEmployeeData();
//   }, []);

//   const fetchNotifications = async () => {
//     try {
//       const response = await fetch(`/api/notification/${user_id}`);
//       const data = await response.json();
//       setMessages(data.messages || []);
//       setUnreadCount(data.unread_count || 0);
//     } catch (error) {
//       console.error("Error fetching notifications:", error);
//     }
//   };

//   useEffect(() => {
//     fetchNotifications();
//     const interval = setInterval(fetchNotifications, 11000);
//     return () => clearInterval(interval);
//   }, [user_id]);

//   const getEmployeeDetails = () => {
//     if (employeeDetails && user_id) {
//       return employeeDetails.find((employee) => employee.id === user_id);
//     }
//     return null;
//   };

//   const loggedInEmployee = getEmployeeDetails();

//   const handleMove = async (url) => {
//     await fetchNotifications();
//     navigate(url);
//   };

//   const handleMenuOpen = (event) => {
//     setAnchorEl(event.currentTarget);
//     setSelected("Profile");
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//     setSelected("");
//   };

//   const handleProfileClick = () => {
//     navigate("/profile");
//     handleMenuClose();
//   };

//   const notificationTooltipContent =
//     messages.length > 0 ? (
//       <Box
//         sx={{
//           width: 400,
//           p: 2,
//           bgcolor: "#fff",
//           borderRadius: 2,
//           boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
//           overflowY: "auto",
//           maxHeight: 450,
//           scrollbarWidth: "none",
//           "&::-webkit-scrollbar": { display: "none" },
//         }}
//       >
//         <Typography
//           variant="h6"
//           sx={{
//             fontWeight: "bold",
//             mb: 2,
//             color: "#5f957a",
//             fontSize: 22,
//           }}
//         >
//           New Notifications
//         </Typography>
//         {messages.map((message, index) => (
//           <Box
//             key={index}
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               mb: 1,
//               pb: 1,
//               borderBottom:
//                 index < messages.length - 1 ? "0.5px solid #e0e0e0" : "none",
//             }}
//           >
//             <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//               <Avatar
//                 alt="Profile"
//                 src={loggedInEmployee?.profile_url || ""}
//                 sx={{
//                   width: 36,
//                   height: 36,
//                   bgcolor: "#e0e0e0",
//                   color: "#6495ed",
//                   fontSize: 24,
//                   border: "1px solid #6495ed",
//                 }}
//               >
//                 {!loggedInEmployee?.profile_url && (
//                   <PersonIcon fontSize="inherit" />
//                 )}
//               </Avatar>
//               <Box>
//                 <Typography
//                   variant="body1"
//                   sx={{ fontWeight: "bold", color: "#333", fontSize: 16 }}
//                 >
//                   {message.message}
//                 </Typography>
//                 <Typography
//                   variant="body2"
//                   sx={{ fontWeight: "bold", color: "#333", fontSize: 14 }}
//                 >
//                   {message.title}
//                 </Typography>
//               </Box>
//             </Box>
//             <Box sx={{ textAlign: "right", minWidth: 110 }}>
//               <Typography
//                 variant="body2"
//                 sx={{ fontWeight: "bold", color: "#333", fontSize: 15 }}
//               >
//                 {message.balance}
//               </Typography>
//               <Typography
//                 variant="caption"
//                 sx={{
//                   fontWeight: "bold",
//                   color: "#333",
//                   textTransform: "uppercase",
//                   fontSize: 12,
//                 }}
//               >
//                 {new Date(message.created_at).toLocaleString("en-US", {
//                   year: "numeric",
//                   month: "short",
//                   day: "numeric",
//                 })}
//               </Typography>
//               <Typography
//                 variant="caption"
//                 sx={{
//                   display: "block",
//                   fontWeight: "bold",
//                   color: "#333",
//                   fontSize: 12,
//                 }}
//               >
//                 {new Date(message.created_at).toLocaleString("en-US", {
//                   hour: "numeric",
//                   minute: "numeric",
//                   hour12: true,
//                 })}
//               </Typography>
//             </Box>
//           </Box>
//         ))}
//       </Box>
//     ) : (
//       <Typography variant="body2">No new notifications</Typography>
//     );

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         height: "100%",
//         gap: "5px",
//         overflow: "visible",
//       }}
//     >
//       <Box
//         sx={{
//           display: isExpanded ? "flex" : "none",
//           flexDirection: "column",
//           height: "100%",
//           width: "125px",

//           gap: "5px",
//           transition: "width 0.3s ease",
//           overflow: "visible",
//         }}
//       >
//         <Box
//           sx={{
//             border: "3px solid #fb7102",
//             borderTopRightRadius: "20px",
//             borderBottomRightRadius: "20px",
//             paddingLeft: "0px !important",
//             height: "66%",
//             overflow: "visible",
//             "& .pro-sidebar": {
//               width: "90px !important",
//               minWidth: "90px !important",
//               marginTop: "-40px !important",
//               overflow: "visible",
//             },
//             "& .pro-sidebar-inner": {
//               background: `white !important`,
//               overflow: "visible",
//             },
//             "& .pro-icon-wrapper": {
//               backgroundColor: "transparent !important",
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//             },
//             "& .pro-inner-item": {
//               padding: "5px 0 !important",
//               display: "flex",
//               justifyContent: "center",
//             },
//             "& .pro-inner-item:hover": {
//               animation: "none",
//             },
//             "& .pro-menu-item .pro-inner-item .pro-item-content": {
//               display: "none",
//             },
//           }}
//         >
//           <img
//             src="/2.png"
//             alt="Sidebar Top"
//             className="top-img"
//             style={{
//               width: 93,
//               height: 48,
//               margin: "16px 13px",
//               position: "fixed",
//             }}
//           />
//           <div
//             className="custom-sidebar"
//             style={{
//               height: "100%",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "flex-start",
//               justifyContent: "flex-start",
//               overflowY: "scroll",
//               overflowX: "visible",
//               msOverflowStyle: "none",
//               scrollbarWidth: "none",
//             }}
//           >
//             <div
//               style={{
//                 flex: 1,
//                 width: "100%",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 overflow: "visible",
//               }}
//             >
//               <Box collapsed={false}>
//                 <div
//                   style={{
//                     width: 200,
//                     height: "53vh",
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     position: "absolute",
//                     top: 70,
//                     left: -39,
//                     overflowX: "visible", // Always show horizontal scrollbar
//                     overflowY: "auto", // Keep vertical scrolling
//                     paddingTop: 0,
//                     minHeight: 0,
//                     whiteSpace: "nowrap", // Enable horizontal scrolling
//                   }}
//                 >
//                   {sidebarData.map((item, index) => {
//                     const { scale, x, zIndex } = getMacDockScale(
//                       index,
//                       hoveredIndex,
//                       sidebarData.length
//                     );
//                     const isHovered = hoveredIndex === index;

//                     return (
//                       <Tooltip
//                         key={item.sidebar_name}
//                         title={item.sidebar_name}
//                         placement="top"
//                         arrow
//                         enterDelay={400} // Show tooltip after 500ms
//                         componentsProps={{
//                           tooltip: {
//                             sx: {
//                               fontSize: "0.95rem",
//                               padding: "8px 12px",
//                               backgroundColor: "#f5f7fa",
//                               color: "#333",
//                               boxShadow: "0 4px 20px rgba(80, 100, 200, 0.10)",
//                             },
//                           },
//                           arrow: {
//                             sx: {
//                               color: "#f5f7fa",
//                             },
//                           },
//                         }}
//                       >
//                         <motion.div
//                           style={{
//                             margin: "32px 0",
//                             position: "relative",
//                             overflow: "visible",
//                             display: "flex",
//                             justifyContent: "center",
//                             alignItems: "center",
//                             zIndex: zIndex,
//                           }}
//                           animate={{
//                             scale,
//                             x,
//                             y: scale > 1 ? -10 * (scale - 1) : 0,
//                           }}
//                           transition={{
//                             type: "spring",
//                             stiffness: 300,
//                             damping: 60,
//                             mass: 2,
//                           }}
//                           onMouseEnter={() => handleMouseEnter(index)}
//                           onMouseLeave={handleMouseLeave}
//                           onClick={() => {
//                             setSelected(item.sidebar_name);
//                             navigate(item.action_link);
//                             if (props.onNavigate)
//                               props.onNavigate(item.action_link);
//                           }}
//                         >
//                           <div
//                             className="icon-container"
//                             style={{
//                               borderRadius: "50%",
//                               width: 40,
//                               height: 40,
//                               gap: "10px",
//                               display: "flex",
//                               justifyContent: "center",
//                               alignItems: "center",
//                               position: "absolute",
//                               overflow: "visible",
//                               backgroundColor: "white",
//                             }}
//                           >
//                             <IconButton
//                               style={{
//                                 fontSize: "2rem",
//                                 color: isHovered ? "#4053b8" : "#527ae3",
//                                 background: "none",
//                                 border: "none",
//                                 boxShadow: "none",
//                                 margin: "5px 0 0 0",
//                               }}
//                               disableRipple
//                               disableFocusRipple
//                             >
//                               {getSidebarIconComponent(item.sidebar_name)}
//                             </IconButton>
//                           </div>
//                         </motion.div>
//                       </Tooltip>
//                     );
//                   })}
//                 </div>
//               </Box>
//             </div>
//           </div>
//         </Box>
//         <Box
//           sx={{
//             border: "3px solid #fb7102",
//             borderTopRightRadius: "20px",
//             borderBottomRightRadius: "20px",
//             height: "34%",
//             overflow: "scroll",
//             "& .pro-sidebar .pro-menu": {
//               paddingBottom: "0px",
//             },
//             "& .pro-sidebar": {
//               width: "90px !important",
//               minWidth: "90px !important",
//               overflow: "visible",
//             },
//             "& .pro-sidebar-inner": {
//               background: `white !important`,
//               overflow: "visible",
//             },
//             "& .pro-icon-wrapper": {
//               backgroundColor: "transparent !important",
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//             },
//             "& .pro-inner-item": {
//               padding: "0px 0 !important",
//               display: "flex",
//               justifyContent: "center",
//             },
//             "& .pro-inner-item:hover": {
//               color: "#868dfb !important",
//             },
//             "& .pro-menu-item.active": {
//               color: "#6870fa !important",
//             },
//             "& .pro-menu-item .pro-inner-item .pro-item-content": {
//               display: "none",
//             },
//           }}
//         >
//           <div
//             style={{
//               marginTop: "15px",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//             }}
//           >
//             <ProSidebar collapsed={false}>
//               <Menu>
//                 <Box
//                   paddingLeft="0"
//                   sx={{
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: "20px",
//                   }}
//                 >
//                   <MenuItem
//                     icon={
//                       <Tooltip
//                         title={notificationTooltipContent}
//                         placement="right"
//                         componentsProps={{
//                           tooltip: {
//                             sx: {
//                               fontSize: "1.25rem",
//                               padding: "10px 16px",
//                               backgroundColor: "#f5f7fa",
//                               color: "#333",
//                               boxShadow: "0 4px 20px rgba(80, 100, 200, 0.10)",
//                             },
//                           },
//                         }}
//                       >
//                         <span style={{ marginTop: "10px" }}>
//                           <IconButton
//                             style={{
//                               color:
//                                 selected === "Notifications"
//                                   ? "#6870fa"
//                                   : "#527ae3",
//                             }}
//                             onClick={() => {
//                               setSelected("Notifications");
//                             }}
//                           >
//                             <Badge badgeContent={unreadCount} color="error">
//                               <NotificationsActiveIcon
//                                 style={{ fontSize: "2.8rem" }}
//                               />
//                             </Badge>
//                           </IconButton>
//                         </span>
//                       </Tooltip>
//                     }
//                   />
//                   <MenuItem
//                     icon={
//                       <Tooltip
//                         title={location || "Location not available"}
//                         placement="right"
//                         arrow
//                         componentsProps={{
//                           tooltip: {
//                             sx: {
//                               fontSize: "0.95rem",
//                               padding: "8px 12px",
//                             },
//                           },
//                           arrow: {
//                             sx: {
//                               color: "#f5f7fa",
//                             },
//                           },
//                         }}
//                       >
//                         <span>
//                           <IconButton
//                             style={{
//                               color:
//                                 selected === "Location" ? "#6870fa" : "#527ae3",
//                             }}
//                             onClick={() => setSelected("Location")}
//                           >
//                             <FmdGoodIcon style={{ fontSize: "3rem" }} />
//                           </IconButton>
//                         </span>
//                       </Tooltip>
//                     }
//                   />
//                   <MenuItem
//                     icon={
//                       <IconButton
//                         style={{
//                           color: selected === "Profile" ? "#6870fa" : "#527ae3",
//                         }}
//                         onClick={handleMenuOpen}
//                       >
//                         {loggedInEmployee ? (
//                           <Avatar
//                             alt="Profile Picture"
//                             src={loggedInEmployee.profile_url}
//                             sx={{ width: 36, height: 36 }}
//                           />
//                         ) : (
//                           <PersonIcon style={{ fontSize: "2.8rem" }} />
//                         )}
//                       </IconButton>
//                     }
//                   />
//                   <MuiMenu
//                     anchorEl={anchorEl}
//                     open={open}
//                     onClose={handleMenuClose}
//                     anchorOrigin={{
//                       vertical: "top",
//                       horizontal: "left",
//                       top: 700,
//                     }}
//                     transformOrigin={{
//                       vertical: "top",
//                       horizontal: "left",
//                     }}
//                     PaperProps={{
//                       style: {
//                         maxHeight: 48 * 4.5,
//                         width: "22ch",
//                         borderRadius: "12px",
//                         background: "#f5f7fa",
//                         boxShadow: "0 4px 20px rgba(80, 100, 200, 0.10)",
//                         marginLeft: "5%",
//                       },
//                     }}
//                     MenuListProps={{
//                       sx: {
//                         display: "flex",
//                         flexDirection: "column",
//                         gap: 1.5,
//                         paddingY: 1,
//                       },
//                     }}
//                   >
//                     <MenuItem
//                       onClick={handleProfileClick}
//                       sx={{
//                         color: "#527ae3",
//                         "&:hover": {
//                           background: "#e3e8fd",
//                           color: "#4053b8",
//                         },
//                       }}
//                     >
//                       <Box display="flex" flexDirection="row" alignItems="left">
//                         <PersonIcon
//                           sx={{ fontSize: "28px", color: "#527ae3" }}
//                         />
//                         <Typography sx={{ fontSize: "20px", color: "gray" }}>
//                           Profile
//                         </Typography>
//                       </Box>
//                     </MenuItem>
//                     <MenuItem value="LogOut" func={props.setIsLoggedIn}>
//                       <Logout func={props.setIsLoggedIn} />
//                     </MenuItem>
//                   </MuiMenu>
//                 </Box>
//               </Menu>
//             </ProSidebar>
//           </div>
//         </Box>
//       </Box>
//       <IconButton
//         onClick={toggleSidebar}
//         sx={{
//           position: "absolute",
//           left: isExpanded ? "100px" : "0px",
//           top: "40%",
//           transform: "translateY(-50%)",
//           backgroundColor: "#fff",
//           border: "3px solid #fb7102",
//           zIndex: 100,
//           borderRadius: "50%",
//           "&:hover": {
//             backgroundColor: "#fb7102",
//           },
//         }}
//       >
//         {isExpanded ? <ChevronLeftIcon /> : <ChevronRightIcon />}
//       </IconButton>
//     </Box>
//   );
// };

// export default Sidebar;


